import React from 'react';
import { BuzzBridgeJobDashboard } from '../../BuzzBridge/BuzzBridgeJobDashboard';
import { ContainerWrapper } from '../../ContainerWrapper/ContainerWrapper';

interface IBuzzInterface {}

const BuzzBridgeJobDashboardContainer: React.FC<IBuzzInterface> = props => {
    return (
        <ContainerWrapper>
            <BuzzBridgeJobDashboard />
        </ContainerWrapper>
    );
};

export { BuzzBridgeJobDashboardContainer };
